// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'
import VueScrollTo from 'vue-scrollto'

Vue.config.productionTip = false
require('./assets/css/main.scss')
Vue.use(VueScrollTo)

Vue.use(ElementUI, { locale })

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	template: '<App @addItem="handleAddItem"/>',
	components: { App },
	data () {
		return {
			categories: [],
			loggedIn: false,
			headers: {},
			brandId: 2,
			userData: {},
			guest: false,
			guestData: {},
			cartId: 0,
			cart: [],
			backendCart: [],
			cardToken: ''
		}
	},
	methods: {
		handleAddItem (newItem) {
			if (!this.cart.length) {
				this.cart.push(newItem)
			} else {
				this.cart.forEach((item, index) => {
					if (item.id === newItem.id) {
						this.cart.splice(index, 1)
					}
				})
				this.cart.push(newItem)
			}
		}
	}
})



// WEBPACK FOOTER //
// ./src/main.js